import { updateVisibiltityStatus } from 'gql/mutations'

export const updateReportCardVisibility = async (candidateDetails: any[]) => {
  try {
    const hasHideVisibilityIds: any[] = []
    const hasProvideVisibilityIds: any[] = []

    for (const candidate of candidateDetails) {
      if (candidate?.visibility) {
        hasHideVisibilityIds.push(candidate?.candidate_id)
      } else {
        hasProvideVisibilityIds.push(candidate?.candidate_id)
      }
    }
    if (hasHideVisibilityIds && hasHideVisibilityIds.length > 0) {
      const responseHideVisibility = await updateVisibiltityStatus(hasHideVisibilityIds, false, 'candidate_report_data', 'candidate_id', 'is_visible')
    }
    if (hasProvideVisibilityIds && hasProvideVisibilityIds.length > 0) {
      const responseProvideVisibility = await updateVisibiltityStatus(
        hasProvideVisibilityIds,
        true,
        'candidate_report_data',
        'candidate_id',
        'is_visible'
      )
    }
    return true
  } catch (err) {
    return null
  }
}

export const changeBulkReportCardVisibility = async (selectedDetails: any[], allCandidateDetails: any[]) => {
  console.log(selectedDetails, 'candidateUuids', allCandidateDetails, 'Candidate details')
  const selectedCandidateIdsWithVisibility = selectedDetails
    .map(({ application_id, id }) => {
      const candidateDetails = allCandidateDetails.find(reportCardDetails => reportCardDetails?.candidate_id === application_id)
      if (candidateDetails) {
        return { candidate_id: application_id, visibility: candidateDetails?.is_visible }
      }
    })
    .filter(Boolean)
  if (selectedCandidateIdsWithVisibility && selectedCandidateIdsWithVisibility?.length > 0) {
    await updateReportCardVisibility(selectedCandidateIdsWithVisibility)
  } else {
    return false
  }
}
